<template>
  <div class="san-filters-cloud--group">
    <div class="san-filters-cloud--group--label">
      {{ label }}:
      <!-- {{ t(`Filter.${label}.label`) }}: -->
    </div>
    <div class="san-filters-cloud--group--chips">
      <q-chip
        v-for="(item, i) in items"
        :key="i"
        icon-remove="mono-cross-circle-solid"
        dense
        removable
        @remove="refine(item)"
      >
        {{ item.label }} ({{ item.count }})
      </q-chip>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'SanFilterCloudGroup' })
const props = defineProps({
  label: { type: String, required: true },
  items: { type: [Array, String], required: true },
  refine: { type: Function, default: () => {} }
})
</script>
